module.exports = __webpack_public_path__ + "img/gps-ic.072d436c.svg";